import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { Module } from '../Module';
import { DeleteSubscriptionsRequest } from '../ServerApi/requests/DeleteSubscriptionsRequest';
import { GetSubscriptionsRequest } from '../ServerApi/requests/GetSubscriptionsRequest';
import { ResumeSubscriptionRequest } from '../ServerApi/requests/ResumeSubscriptionRequest';
import { SetSelfServiceSubscriptionsFrequencyRequest } from '../ServerApi/requests/SetSelfServiceSubscriptionsFrequencyRequest';
import { SetSubscriptionsDataConditionRequest } from '../ServerApi/requests/SetSubscriptionDataConditionRequest';
import { SetSubscriptionsFormatRequest } from '../ServerApi/requests/SetSubscriptionsFormatRequest';
import { SetSubscriptionsFrequencyRequest } from '../ServerApi/requests/SetSubscriptionsFrequencyRequest';
import { SetSubscriptionsScheduleRequest } from '../ServerApi/requests/SetSubscriptionsScheduleRequest';
import { SetSubscriptionsSelfServiceScheduleRequest } from '../ServerApi/requests/SetSubscriptionsSelfServiceSchedule';
import { SetSubscriptionSubjectRequest } from '../ServerApi/requests/SetSubscriptionSubjectRequest';
import { ISetSelfServiceScheduleParams, ISetSelfServiceSubscriptionsFrequencyParams, ISetSubscriptionsFormatParams, ISetSubscriptionsFrequencyParams } from '../ServerApi/types/actionParams';
import { IResult } from '../ServerApi/types/IResponse';
import { SelfServiceSchedule } from '../ServerApi/types/SelfServiceSchedule';
import { SubscriptionDataConditionType } from '../ServerApi/types/SubscriptionDataCondition';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class Subscriptions extends Resource<ISubscriptionInfo> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetSubscriptionsRequest,
      ServerApiMapper.subscriptions));
  }

  public del(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteSubscriptionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  resume(id: string): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new ResumeSubscriptionRequest(id));
  }

  setSchedule(ids: string[], scheduleId: string) {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  setSelfServiceSchedule(ids: string[], schedule: SelfServiceSchedule) {
    const params: ISetSelfServiceScheduleParams = { ids: ids, schedule: schedule };
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) =>
        new SetSubscriptionsSelfServiceScheduleRequest(params)),
      ResultHelper.combineResults);
  }

  changeSubject(id: string, subject: string): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new SetSubscriptionSubjectRequest(id, subject));
  }

  changeDataCondition(ids: string[], dataConditionType: SubscriptionDataConditionType): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new SetSubscriptionsDataConditionRequest({ ids, dataConditionType }));
  }

  changeFormat(ids: string[], attachImage: boolean, attachPdf: boolean): IPromise<IResult> {
    const params: ISetSubscriptionsFormatParams = { ids: ids, attachImage: attachImage, attachPdf: attachPdf };
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFormatRequest(params)),
      ResultHelper.combineResults);
  }

  changeFrequency(ids: string[], scheduleId: string, subscribeOnExtractRefresh: boolean): IPromise<IResult> {
    const params: ISetSubscriptionsFrequencyParams = { ids: ids, scheduleId: scheduleId, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }

  changeSelfServiceSubscriptionsFrequency(ids: string[], schedule: SelfServiceSchedule, subscribeOnExtractRefresh: boolean): IPromise<IResult> {
    const params: ISetSelfServiceSubscriptionsFrequencyParams = { ids: ids, schedule: schedule, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSelfServiceSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }
}

Module.instance().service('Subscriptions', Subscriptions);
